export default __webpack_public_path__ + "static/media/MC Status Dark.dfbea50b.png";